import {
  KnownDeliveryDtoDeliveryType,
  KnownProjectModuleSettingsDtoName
} from '@groundfloor-platform/mgmt-service-g-sdk';

export const deliveryTypeToProjectModuleMap: Record<KnownDeliveryDtoDeliveryType, KnownProjectModuleSettingsDtoName> = {
  [KnownDeliveryDtoDeliveryType.InboundDryCleaning]: KnownProjectModuleSettingsDtoName.DryCleaning,
  [KnownDeliveryDtoDeliveryType.OutboundDryCleaning]: KnownProjectModuleSettingsDtoName.DryCleaning,
  [KnownDeliveryDtoDeliveryType.InboundMail]: KnownProjectModuleSettingsDtoName.InboundMail,
  [KnownDeliveryDtoDeliveryType.OutboundMail]: KnownProjectModuleSettingsDtoName.OutboundMail,
  [KnownDeliveryDtoDeliveryType.InboundParcel]: KnownProjectModuleSettingsDtoName.InboundParcel,
  [KnownDeliveryDtoDeliveryType.PeerToPeer]: KnownProjectModuleSettingsDtoName.PeerToPeer,
  [KnownDeliveryDtoDeliveryType.RetailOrder]: KnownProjectModuleSettingsDtoName.ClickAndCollect,
  [KnownDeliveryDtoDeliveryType.LockerpointOrder]: KnownProjectModuleSettingsDtoName.LockerpointOrders
};
